import { render, staticRenderFns } from "./MimeTalkService.vue?vue&type=template&id=68275754&scoped=true"
import script from "./MimeTalkService.vue?vue&type=script&lang=js"
export * from "./MimeTalkService.vue?vue&type=script&lang=js"
import style0 from "./MimeTalkService.vue?vue&type=style&index=0&id=68275754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68275754",
  null
  
)

export default component.exports